import type {
  IActionPanelAPI,
  IActionContextAPI,
} from '@wix/editor-platform-host-integration-apis';

export interface IActionContextContributor {
  getActionContextOverrides(): Partial<IActionContextAPI>;
}

export function isActionContextContributor(
  api: IActionPanelAPI,
): api is IActionPanelAPI & IActionContextContributor {
  return 'getActionContextOverrides' in api;
}
